export const cardStories = [
  {
    id: 202306,
    name: '《梦想地》',
    author: {},
    story: '照片拍摄于法属波利尼西亚莫雷阿岛的一个沙洲，那里的鲨鱼游得十分靠近海滩，甚至在岛民的院子门前就可以看到。早晨的海水十分平静和清澈，大家可以在浅滩上花上几个小时观看这些优雅的生物而在这张照片上呈现的黑鳍礁鲨也是众多潜水员喜爱的鲨鱼之一，它们性情温和，通常生活在温暖的浅水水域。黑鳍礁鲨非常容易识别，它们的胸鳍和背鳍的顶端为明显的黑色，体侧有白色的条纹，容易辨识，常见于印度-太平洋海域。',
    imageUrl: "https://img.yzcdn.cn/upload_files/2023/08/10/FuoYLVPn9YH241d3WUDFywAYw20i.jpg"
  },
  {
    id: 202401,
    name: '《冬日掠食》',
    author: {},
    story: '“让自然本身诉说美丽，通过摄影描绘海洋居民，展示我们星球上隐藏的宝藏。”这张照片是在挪威北部的一个叫Skjervay小渔村附近拍摄的。 每年冬天，大量的鲱鱼会从公海迁徙到挪威北部的峡湾，吸引大量的大型掠食者，如:逆戟鲸和座头鲸。 挪威冬季的白天较短，气候寒冷，冬天处于极夜的环境，水中活动和摄影充满挑战。所以每年只有几天有机会同时看到阳光入水和峡湾里的鲸鱼。 这张照片就是在这样的一天拍摄的。',
    imageUrl: "https://img.yzcdn.cn/upload_files/2024/03/29/FigM5-c9DmmkHd3AaS3N6LQ_NjPX.jpg"
  },
  {
    id: 202402,
    name: '《海底飞行》',
    author: {
      name: '雷应涛',
      desc: ['PADI美人鱼教练训练官/首届中国美人鱼表演赛双料冠军', '2023中国美人鱼公开赛双料冠军'],
      sign: '',
      imgName: 'Leiyingtao'
    },
    story: '在马尔代夫船宿的夜晚，每条船的船尾都亮着大灯，无数的浮游生物趋光而来，就像在大海上盛大的自助餐晚宴。那天我们的船尾吸引了7只MANTA同时出现，它们时而像飞船一样在海底潜行，时而来到水面翻滚着肚皮享受饕餮盛宴。每一只MANTA后背的纹路都不尽相同，巨大的MANTA在水下煽动着翅膀，无比优雅的飞行。有趣的是这张照片里的一只MANTA的翅膀还缺了一个小角，或许它也有着自己的经历吧。',
    imageUrl: "https://img.yzcdn.cn/upload_files/2024/03/29/FkSUeNZkhTHyIjSpvyZkLx8PGRmK.jpg"
  },
  {
    id: 202404,
    name: '《静止的时间》',
    author: {
      name: 'Tom St. George.',
      desc: [],
      sign: '',
      imgName: 'default-author'
    },
    story: '这张照片拍摄于墨西哥图卢姆（Tulum, Mexico）附近，记录了Cenote Angelita 的梦幻场景。照片中的潜水员是摄影师的妻子 Julia，他们将这个场景描述为：坍塌的碎石、树枝和落叶掉入洞穴组成的“小岛”，坐落在硫化氢的“云层”中。光线被水柱漫射，然后被“云层”反射，非常迷人。摄影师本人最喜欢这张照片的原因是它捕捉到了洞穴的精髓。',
    imageUrl: "https://img.yzcdn.cn/upload_files/2024/10/18/FuRIcWJHwKuT_lY_0RtN05Gj-4No.jpg"
  },
  {
    id: 202304, 
    name: '《寂静深蓝》',
    author: {
      name: '周杞楠（楠忘）',
      sign: '旅行、海洋、影像、人生，用影像记录行走的人生',
      desc: ['潜行家创始人/视觉中国签约摄影师/CCTV合作水下摄影师/8K RAW Premier签约摄影师'],
      imgName: 'Zhouqinan'
    },
    story: '这是在汤加海域观察到的一只，身形不太协调的幼年座头鲸。上颚明显畸形，可能是先天基因所致，也可能是意外受伤。没有鲸群家族的陪伴，孤独的潜浮在海平面之下，虽是独处，但更像是讲述着自己的故事。',
    imageUrl: "https://img.yzcdn.cn/upload_files/2023/04/13/FgLBXTmQ6vb8h4HZgVcdvQ2WS8Et.jpg"
  },
  {
    id: 202403,
    name: '《庇护所》',
    author: {
      name: 'Martin Strmiska',
      desc: [],
      sign: '',
      imgName: 'default-author'
    },
    story: '这张照片拍摄于菲律宾卡比劳(Cabilao，Philippines)，摄影师在珊瑚礁进行晨潜时，偶然发现了这充满活力的组合:一对小丑鱼和它们的虾伙伴在海葵天鹅绒般的紫色触须中找到了庇护所。海葵最初是完全闭合的，两只小丑鱼拼命躲在几根触手之间，好奇地张望着探访者的到来。而眼前美丽色彩的呈现，促使摄影师逗留，静静等待海葵张开，并拍下了美丽的瞬间。',
    imageUrl: "https://img.yzcdn.cn/upload_files/2024/10/18/Fn7B1AxRe0Q9jrSMDDu1g9xLqt98.jpg"
  },
  {
    id: 202501,
    name: '《静谧之舟》',
    author: {
      name: 'Alex Dawson',
      desc: [],
      sign: '',
      imgName: 'default-author'
    },
    story: '这张照片拍摄于埃及红海的 Shaabruhr Umm Qammar.东北端，沉船 Gulf Fleet 31 在海里的最大深度为104米，被夹在海下的一个坡道和珊瑚礁顶部之间，为混合气潜水员提供了可以在船体下方进行穿越游览的独特机会。',
    imageUrl: "https://img.yzcdn.cn/upload_files/2025/01/10/Fj8VR8pEirblaJuGWsJqX5BoccIw.jpg"
  },
  {
    id: 202502,
    name: '《海底之恋》',
    author: {
      name: 'Gabriel Guzman',
      desc: [],
      sign: '',
      imgName: 'default-author'
    },
    story: '这张照片拍摄于大堡礁的 Moore Reef。这里的海龟交配季节是非常特殊的一段时期，因为海龟们表现出了一年中其他时间没有的独特行为，这让摄影师有机会拍摄到它们“为爱而战”的场景。这张照片的一切都非常理想：海洋环境丰富，能见度高，阳光明媚，还有海龟的活动场景。',
    imageUrl: "https://img.yzcdn.cn/upload_files/2025/01/10/FmbEbcTDo7tMvduIBGAXwlbaFdrx.jpg"
  }
]